// src/components/store/sections/hero-banner/HeroV89GlassislandSlateGold.tsx
"use client";

import React from "react";
import DynamicHeroVariant from "./DynamicHeroVariant";

export default function HeroV89GlassislandSlateGold(props: any) {
  return (
    <DynamicHeroVariant
      variantNumber={89}
      archKey="glass_island"
      archLabel="Frosted Glass Island"
      palName="SlateGold"
      grad="from-slate-800 via-zinc-900 to-neutral-950"
      lightBg="bg-amber-50/80"
      textCol="text-amber-700"
      borderCol="border-amber-300"
      btnCls="bg-slate-900 hover:bg-slate-800"
      {...props}
    />
  );
}
